<template>
  <div class="flex justify-content-center">
    <button 
        @click="logout" 
        class="w-full p-link flex align-items-center p-2 pl-4 text-color hover:surface-200 border-noround"
    >
        <span class="material-icons icon-class pr-2">logout</span>
    </button>
</div>

</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useAuthStore } from "@/store/modules/auth";


export default defineComponent({
  name: "UserDropdown",
  props: {
    workingSpacePath: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      logoutUrl: '/logout',
      authStore: useAuthStore(),
    }
  },
  methods: {
    toggle(event: Event) {
      this.menu.toggle(event);
    },
    logout(){
      this.authStore.logout();
    }
  },
  setup() {
    const menu = ref();
    return {
      menu,
    };
  },
});
</script>

<style>
#overlay_menu.user-navbar-overlay-menu{
    margin-top: 0.7rem;
}
</style>
<style src="./user-dropdown.scss" lang="scss" scoped />
